//= include ../../../node_modules/aos/dist/aos.js

AOS.init({
  disable: 'mobile',
  once: true
});

window.addEventListener('load', AOS.refresh);

function refreshAOS() {
  AOS.refresh();
}